/**
 * Models Popover
 * Icona che apre un pannello con l'elenco dei modelli CAN che gestiscono un segnale/campo.
 * Usato nel Catalogo segnali (canMaps) e nella configurazione Mappa (availableInModels).
 *
 *   <app-models-popover [models]="attr.canMaps"></app-models-popover>
 */
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMicrochip, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-models-popover',
  standalone: true,
  imports: [CommonModule, FormsModule, MatMenuModule, MatTooltipModule, FontAwesomeModule, TranslateModule],
  templateUrl: './models-popover.component.html',
  styleUrls: ['./models-popover.component.scss']
})
export class ModelsPopoverComponent {
  /** Elenco dei modelli; con lista vuota l'icona non viene mostrata */
  @Input() models: string[] | null | undefined = [];
  /** Nome del segnale/campo, mostrato nell'intestazione del pannello */
  @Input() signalName: string = '';

  faMicrochip = faMicrochip;
  faSearch = faSearch;
  faTimes = faTimes;

  search = '';

  get hasModels(): boolean {
    return !!this.models && this.models.length > 0;
  }

  /** Modelli filtrati dalla ricerca (utile quando sono molti), in ordine alfabetico */
  get filteredModels(): string[] {
    const list = [...(this.models ?? [])].sort((a, b) => a.localeCompare(b));
    const q = this.search.trim().toLowerCase();
    return q ? list.filter(m => m.toLowerCase().includes(q)) : list;
  }

  onMenuClosed(): void {
    this.search = '';
  }
}
